import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import AOS from 'aos';
import 'aos/dist/aos.css';

import heroResmi from '../assets/Ankara-Teknik-Servis.webp';
import hakkımızdaResmi from '../assets/hakkımızda-resim.webp';
import hizmetlerimizResmi from '../assets/hizmetler-resim.webp';

function Home() {
  // SSS İÇİN DURUM YÖNETİMİ
  const [activeIndex, setActiveIndex] = useState(null); // İlk soru açık gelsin

  // AOS ANİMASYONLARINI BAŞLATMA SİHRİ
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true, // Animasyonlar sayfa aşağı kayarken 1 kere çalışır
      offset: 100,
    });
  }, []);

  const toggleFaq = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  // --- GOOGLE İÇİN GÖRÜNMEZ SEO ŞEMASI (JSON-LD) ---
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Ankara Merkez Teknik",
    "description": "Ankara'da Keçiören, Çankaya, Yenimahalle başta olmak üzere tüm ilçelere 7/24 garantili kombi, klima, çamaşır ve bulaşık makinesi teknik servis hizmeti.",
    "telephone": "+903125810881",
    "areaServed": [
      "Keçiören", "Altındağ", "Mamak", "Çankaya", 
      "Pursaklar", "Yenimahalle", "Eryaman", "Sincan"
    ],
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Ankara",
      "addressRegion": "Ankara",
      "addressCountry": "TR"
    },
    "priceRange": "₺₺",
    "openingHours": "Mo-Su 00:00-23:59", // 7/24 Açık
    "url": "https://ankaramerkezteknik.com.tr" // Domainini buraya yazarsın canlıya alırken
  };

  // SİHİRLİ SEO SORULARI
  const faqs = [
    {
      soru: "Ankara'nın hangi ilçelerinde teknik servis hizmetiniz var?",
      cevap: "Ankara'nın her noktasına 7/24 kesintisiz ulaşıyoruz. Keçiören teknik servis, Çankaya, Yenimahalle teknik servis, Mamak, Eryaman, Sincan, Altındağ ve Pursaklar teknik servis talepleriniz için gezici araçlarımızla aynı gün, hızlı ve garantili hizmet veriyoruz."
    },
    {
      soru: "Kombi bakımı ve tamirinde hangi markalara hizmet veriyorsunuz?",
      cevap: "Vaillant ankara kombi servisi başta olmak üzere; Viessmann, Buderus, Demirdöküm, Baymak, E.C.A, Alarko ve Bosch kombi teknik servis işlemlerinizi uzman ekiplerimizle yapıyoruz. Ayrıca Protherm, Ariston, Ferroli ve Daikin ankara kombi servisi ihtiyaçlarınızda, en uygun ankara kombi bakım fiyatları ile orijinal parça desteği sunuyoruz."
    },
    {
      soru: "İthal ve özel beyaz eşya markalarının tamirini yapıyor musunuz?",
      cevap: "Kesinlikle. Arçelik yetkili servis özeninde; Beko, Siemens, Vestel, Samsung, Profilo ve LG markalarına destek sunuyoruz. Ayrıca Electrolux, AEG, Whirlpool, Indesit, Miele, Hotpoint ve Grundig ankara teknik servis ağımızla; çamaşır makinesi tamircisi ve buzdolabı teknik servis taleplerinizi eksiksiz karşılıyoruz."
    },
    {
      soru: "Alt markalar ve diğer iklimlendirme sistemlerine bakıyor musunuz?",
      cevap: "Evet, her markaya özel ustamız mevcuttur. Altus, Regal, SEG ankara teknik servis işlemlerinin yanı sıra; Immergas, Warmhaus, Termoteknik ve Airfel kombi tamiri taleplerinizi kvk teknik servis hassasiyetiyle onarıyoruz. Ankara klima servisi olarak Arçelik, Beko ve Vestel klimalarınızın bakımını eksiksiz tamamlıyoruz."
    },
    {
      soru: "Acil arızalarda adresime ne kadar sürede ulaşırsınız?",
      cevap: "Bize ulaştığınızda '7/24 ankara kombi servisi 1 km içinde' hızında, size en yakın bölgedeki gezici ekibimizi yönlendiriyoruz. Samsung ankara buzdolabı servisi veya ankara bulaşık makinesi servisi arayışlarınızda beklemeden, cihazlarınızı ilk günkü verimliliğine ulaştırıyoruz."
    }
  ];

  const data = [
    { name: '1. Yıl', verim: 100, faturatag: 'Normal' },
    { name: '2. Yıl', verim: 85, faturatag: '%15 Artış' },
    { name: '3. Yıl', verim: 65, faturatag: '%25 Artış' },
    { name: '4. Yıl', verim: 40, faturatag: '%35 Artış' },
    { name: '5. Yıl', verim: 15, faturatag: '%50 Artış' },
  ];

  return (
    <div className="home-page">
      
      <Helmet>
        <title>Ankara Merkez Teknik | 7/24 Kombi, Klima ve Beyaz Eşya Servisi</title>
        <meta name="description" content="Ankara'da Keçiören, Çankaya, Yenimahalle başta olmak üzere tüm ilçelere 7/24 garantili kombi, klima, çamaşır ve bulaşık makinesi teknik servis hizmeti." />
        <meta name="keywords" content="ankara teknik servis, ankara kombi servisi, ankara beyaz eşya tamiri, klima servisi ankara, garantili teknik servis" />
        {/* Helmet İçine JSON-LD Şeması */}
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>

      {/* --- 1. AÇIK TEMA GİRİŞ (HERO) VE KAYAN MARKALAR --- */}
      <section className="hero-section">
        <div className="hero-left" data-aos="fade-right">
          <span className="hero-badge">Hoş Geldiniz,</span>
          <h1>Ankara Teknik Servis</h1>
          <p>Kombi, klima, buzdolabı ve tüm beyaz eşyalarınızda yaşanan sorunlar artık dert değil. Uzman kadromuzla hızlı, garantili ve yerinde çözüm sunuyoruz.</p>
          <div className="hero-buttons">
            <a href="tel:03125810881" className="btn-primary">Hemen Bizi Ara</a>
            <Link to="/hakkimizda" className="btn-outline">Hakkımızda</Link>
          </div>
          <div className="hero-stats">
            <div className="stat-item"><h3>15+</h3><p>Yıllık Tecrübe</p></div>
            <div className="stat-item"><h3>%100</h3><p>Müşteri Memnuniyeti</p></div>
            <div className="stat-item"><h3>7/24</h3><p>Kesintisiz Destek</p></div>
          </div>
        </div>
        <div className="hero-right" data-aos="fade-left" data-aos-delay="200">
          <div className="hero-image-wrapper">
            <div className="hero-blob"></div>
            <img src={heroResmi} alt="Ankara Teknik Servis" className="hero-main-img" />
          </div>
        </div>
      </section>

      <section className="brands-section" data-aos="fade-in">
        <p>Tüm Lider Markalara Profesyonel Çözüm Sağlıyoruz</p>
        <div className="brands-marquee-container">
          <div className="brands-marquee-track">
            <div className="brands-group">
              <span className="brand-tag">BOSCH</span><span className="brand-tag">ARÇELİK</span><span className="brand-tag">BEKO</span><span className="brand-tag">DEMİRDÖKÜM</span><span className="brand-tag">BAYMAK</span><span className="brand-tag">SAMSUNG</span><span className="brand-tag">VESTEL</span><span className="brand-tag">SIEMENS</span><span className="brand-tag">LG</span><span className="brand-tag">VAILLANT</span><span className="brand-tag">BUDERUS</span>
            </div>
            <div className="brands-group">
              <span className="brand-tag">BOSCH</span><span className="brand-tag">ARÇELİK</span><span className="brand-tag">BEKO</span><span className="brand-tag">DEMİRDÖKÜM</span><span className="brand-tag">BAYMAK</span><span className="brand-tag">SAMSUNG</span><span className="brand-tag">VESTEL</span><span className="brand-tag">SIEMENS</span><span className="brand-tag">LG</span><span className="brand-tag">VAILLANT</span><span className="brand-tag">BUDERUS</span>
            </div>
          </div>
        </div>
      </section>

      <div className="orange-divider"></div>

      {/* --- 2. KOYU TEMA AKIŞ: HAKKIMIZDA --- */}
      <section className="about-premium-section">
        <div className="about-premium-container">
          <div className="about-left-image" data-aos="fade-right">
            <img src={hakkımızdaResmi} alt="Ankara Teknik Servis Ustası" className="main-img" />
            <div className="floating-badge" data-aos="zoom-in" data-aos-delay="300">
              <span className="number">15+</span>
              <span className="text">Yıllık Deneyim</span>
            </div>
          </div>
          <div className="about-right-content" data-aos="fade-left">
            <span className="section-subtitle">Biz Kimiz?</span>
            <h2>Evinizin ve İş Yerinizin Gizli Kahramanları</h2>
            <p>Ankara genelinde beyaz eşya, kombi ve klima sistemleriniz için profesyonel tamir ve bakım hizmeti sunuyoruz. Amacımız arızaları en hızlı şekilde giderirken, cihazlarınızın ilk günkü performansıyla çalışmasını sağlamaktır.</p>
            <div className="feature-cards">
              <div className="f-card" data-aos="fade-up" data-aos-delay="100">
                <div className="icon">⏱️</div>
                <div>
                  <h4>Hızlı ve Garantili Çözüm</h4>
                  <p>Gezici araçlarımızla arızalara aynı gün müdahale ediyor, orijinal yedek parça kullanarak kalıcı onarım sağlıyoruz.</p>
                </div>
              </div>
              <div className="f-card" data-aos="fade-up" data-aos-delay="200">
                <div className="icon">🔧</div>
                <div>
                  <h4>Uzman Teknisyenler</h4>
                  <p>Sektördeki tüm lider markaların teknolojilerine hakim, sertifikalı ve tecrübeli ustalarla çalışıyoruz.</p>
                </div>
              </div>
            </div>
            <Link to="/hakkimizda" className="btn-primary" style={{ display: 'inline-block', marginTop: '15px' }} data-aos="fade-up" data-aos-delay="300">Daha Fazla Bilgi</Link>
          </div>
        </div>
      </section>

      <div className="orange-divider"></div>

      {/* --- 3. BEYAZ TEMA: HİZMET AĞIMIZ --- */}
      <section className="white-districts-section">
        <div className="white-districts-container">
          <div className="section-heading-white" data-aos="fade-down">
            <span className="sub-tag-orange">HİZMET AĞIMIZ</span>
            <h3>Başkentin Her Noktasındayız</h3>
            <p>Ankara'nın neresinde olursanız olun, gezici ekiplerimizle kapınızdayız.</p>
          </div>
          {/* Animasyonun bozulmaması için kayan içeriğe aos vermiyoruz, sarmalayıcıya veriyoruz */}
          <div className="districts-list-white" data-aos="fade-in" data-aos-delay="200">
            {/* 1. ORİJİNAL LİSTE */}
            {[
              "Keçiören", "Altındağ", "Mamak", "Çankaya", 
              "Pursaklar", "Yenimahalle", "Eryaman", "Sincan"
            ].map((item, index) => (
              <span key={`orig-${index}`} className="district-tag-white">
                📍 {item}
              </span>
            ))}

            {/* 2. KOPYA LİSTE */}
            {[
              "Keçiören", "Altındağ", "Mamak", "Çankaya", 
              "Pursaklar", "Yenimahalle", "Eryaman", "Sincan"
            ].map((item, index) => (
              <span key={`dup-${index}`} className="district-tag-white mobile-duplicate">
                📍 {item}
              </span>
            ))}
          </div>
        </div>
      </section>

      <div className="orange-divider"></div>

      {/* --- 4. KOYU TEMA: HİZMETLERİMİZ --- */}
      <section className="services-premium-section">
        <div className="services-premium-container">
          <div className="srv-premium-left" data-aos="fade-right">
            <span className="section-subtitle">Neler Yapıyoruz?</span>
            <h2>Garantili ve Profesyonel Teknik Çözümler</h2>
            <p>Evinizdeki tüm iklimlendirme ve beyaz eşya sistemleri için tek noktadan, %100 orijinal parça destekli servis hizmeti sunuyoruz.</p>
            <div className="srv-list-tech">
              <div className="srv-item-tech" data-aos="fade-up" data-aos-delay="100">
                <div className="srv-icon-tech">🔥</div>
                <div className="srv-content-tech">
                  <h4>Kombi Tamiri ve Bakımı</h4><p>Arıza tespiti, periyodik kışlık bakım ve petek temizliği ile kışa hazırlık.</p>
                </div>
              </div>
              <div className="srv-item-tech" data-aos="fade-up" data-aos-delay="200">
                <div className="srv-icon-tech">❄️</div>
                <div className="srv-content-tech">
                  <h4>Klima Servisi</h4><p>Gaz dolumu, filtre temizliği, kart tamiri, söküm ve montaj işlemleri.</p>
                </div>
              </div>
              <div className="srv-item-tech" data-aos="fade-up" data-aos-delay="300">
                <div className="srv-icon-tech">🧊</div>
                <div className="srv-content-tech">
                  <h4>Buzdolabı Tamiri</h4><p>Kompresör değişimi, soğutmama sorunu çözümü ve gaz şarjı.</p>
                </div>
              </div>
              <div className="srv-item-tech" data-aos="fade-up" data-aos-delay="400">
                <div className="srv-icon-tech">👕</div>
                <div className="srv-content-tech">
                  <h4>Çamaşır & Bulaşık Makinesi</h4><p>Sesli çalışma, su boşaltmama ve ana kart arızalarına kesin onarım.</p>
                </div>
              </div>
            </div>
            <Link to="/iletisim" className="btn-primary" style={{ display: 'inline-block', marginTop: '15px' }}>İletişime Geç</Link>
          </div>
          <div className="srv-premium-right" data-aos="zoom-in" data-aos-delay="200">
            <img src={hizmetlerimizResmi} alt="Ankara Teknik Servis Ustası" className="srv-main-img" />
          </div>
        </div>
      </section>

      <div className="orange-divider"></div>

      {/* --- 5. BEYAZ TEMA: İSTATİSTİK VE ANALİZ --- */}
      <section className="stats-analysis-section white-version">
        <div className="stats-container">
          <div className="section-heading-white" data-aos="fade-up">
            <span className="sub-tag-orange">MÜHENDİSLİK ANALİZİ</span>
            <h3>Cihaz Verimlilik ve Kayıp Grafiği</h3>
            <p>Bakımı yapılmayan cihazların zaman içindeki performans kaybını gerçek verilerle inceleyin.</p>
          </div>
          <div className="stats-grid-wrapper">
            <div className="stats-visual-box light-box recharts-container" data-aos="fade-right" data-aos-delay="200">
              <div className="visual-header"><span>📊 Yıllara Göre Çalışma Performansı (%)</span></div>
              <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                    <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{fill: '#64748b', fontSize: 12}} />
                    <YAxis axisLine={false} tickLine={false} tick={{fill: '#64748b', fontSize: 12}} domain={[0, 100]} />
                    <Tooltip cursor={{fill: '#f8fafc'}} contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 10px 15px rgba(0,0,0,0.1)' }} />
                    <Bar dataKey="verim" radius={[8, 8, 0, 0]} animationDuration={2000}>
                      {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.verim > 70 ? '#0284c7' : entry.verim > 30 ? '#ea580c' : '#ef4444'} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="chart-footer-text">* Veriler, bakımı yapılmayan standart bir cihazı baz almaktadır.</div>
            </div>
            <div className="stats-data-content" data-aos="fade-left" data-aos-delay="400">
              <div className="data-row"><div className="data-icon blue-bg">💰</div><div className="data-text"><h4>Gizli Fatura Maliyeti</h4><p>Düşük verim, yıllık <strong>%35 ekstra maliyete</strong> neden olur.</p></div></div>
              <div className="data-row"><div className="data-icon blue-bg">⚙️</div><div className="data-text"><h4>Sistem Yorgunluğu</h4><p>4. yıldan itibaren <strong>metal yorgunluğu</strong> arıza verir.</p></div></div>
              <div className="data-row"><div className="data-icon blue-bg">🛡️</div><div className="data-text"><h4>Ömür Uzatma Garantisi</h4><p>Periyodik kontroller cihaz ömrünü <strong>15 yıla</strong> kadar sabitler.</p></div></div>
            </div>
          </div>
        </div>
      </section>

      {/* ========================================================== */}
      {/* --- 6. YENİ TASARIM: SSS (SEO) & HIZLI ARAMA MODÜLÜ --- */}
      {/* ========================================================== */}
      <section className="faq-support-section">
        <div className="faq-support-container">
          
          <div className="section-heading-dark" data-aos="fade-down">
            <span className="sub-tag-orange">BİLGİ & DESTEK MERKEZİ</span>
            <h3>Sıkça Sorulan Sorular</h3>
            <p>Hizmet ağımız, garantilerimiz ve çalışma prensiplerimiz hakkında detaylar.</p>
          </div>

          <div className="faq-support-grid">
            
            {/* SOL TARAF: SSS AKORDEON (SEO ODAKLI) */}
            <div className="faq-left-col" data-aos="fade-right" data-aos-delay="200">
              <div className="faq-accordion-new">
                {faqs.map((faq, index) => (
                  <div 
                    key={index} 
                    className={`faq-card ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => toggleFaq(index)}
                  >
                    <div className="faq-header">
                      <h4>{faq.soru}</h4>
                      <div className="icon-wrapper">
                        <span className="plus-minus">{activeIndex === index ? '−' : '+'}</span>
                      </div>
                    </div>
                    <div className="faq-body">
                      <p>{faq.cevap}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* SAĞ TARAF: LÜKS ARAMA (CALL CENTER) MODÜLÜ */}
            <div className="support-right-col" data-aos="fade-left" data-aos-delay="400">
              <div className="call-action-card">
                <div className="pulse-ring"></div>
                <div className="call-icon-box">📞</div>
                
                <h3>Acil Teknik Destek</h3>
                <p>Cihazınız mı bozuldu? Hiç beklemeden uzman ekiplerimize ulaşın, aynı gün kapınıza gelelim.</p>
                
                <div className="phone-number-display">
                  <span>0312 581 08 81</span>
                </div>
                
                <a href="tel:03125810881" className="btn-call-now">
                  Hemen Ara
                </a>

                <div className="trust-badges">
                  <span>✅ 7/24 Hizmet</span>
                  <span>✅ 30 Dk. İçinde Dönüş</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;